import TaskSubType from "../../interfaces/task/TaskSubType";

export async function getTaskTypes(
  authToken: string,
): Promise<TaskSubType[] | null> {
  try {
    let apiUrl: string = `${process.env.REACT_APP_API_BASE_URL}/lookup/TaskTypes`;

    const response = await fetch(apiUrl, {
      headers: {
        Authorization: `Bearer ${authToken}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      console.log(response);
      return null;
    }

    const taskTypesData = await response.json();

    // Explicitly map the 'name' property from the API response to 'type'
    const taskTypes: TaskSubType[] = taskTypesData.map((item: any) => ({
      id: item.id,
      type: item.name,
    }));

    return taskTypes;
  } catch (error) {
    console.error("Error fetching task types:", error);
    return null;
  }
}